import React, { Component } from 'react';
import { connect } from 'dva';
import { stringify } from 'qs';
import moment from 'moment';
import { Button, Row, Col, Form, DatePicker, Input, Tooltip, message, Icon, Tabs } from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import { columns, reporterColumns } from './tableHeader';
import styles from './index.less';
import { getAppCode } from '../../utils/utils';
import { url } from '../../services/service-utils';

const { RangePicker } = DatePicker;
const { ListTable } = ListPage;
const { TabPane } = Tabs;

@connect(({ publish, user }) => ({
  orgId: user.currentUser.orgId,
  ...publish,
}))
class Publish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: ['month', 'month'],
      value: [moment(), moment()],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        searchOrgName: '',
        appCode: getAppCode(),
        nodeId: props.orgId,
        page: 1,
        pageSize: 10,
        startMonth: moment().format('YYYY-MM'),
        endMonth: moment().format('YYYY-MM'),
      },
      activeKey: 'key1',
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchReleaseOrgList(params);
  }

  fetchReleaseOrgList = params => {
    const { dispatch } = this.props;
    const { activeKey } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: `publish/${activeKey === 'key1' ? 'fetchReleaseOrgList' : 'fetchReleaseUserList'}`,
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  search = e => {
    e.preventDefault();
    const { value } = this.state;
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const year = Number(value[1].format('YYYY') - value[0].format('YYYY'));
        if (
          year > 1 ||
          (year === 1 && Number(value[1].format('MM') - value[0].format('MM') >= 0))
        ) {
          return message.warning('最多支持筛选12个月数据');
        }
        const tempParams = {
          ...params,
          searchOrgName: values.searchOrgName ? encodeURIComponent(values.searchOrgName) : '',
          startMonth: value
            ? value[0].format('YYYY-MM')
            : moment()
                .startOf('month')
                .format('YYYY-MM'),
          endMonth: value ? value[1].format('YYYY-MM') : moment().format('YYYY-MM'),
          page: 1,
        };

        this.setState({
          params: tempParams,
        });
        this.fetchReleaseOrgList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = {
      ...params,
      searchOrgName: '',
      page: 1,
      startMonth: moment().format('YYYY-MM'),
      endMonth: moment().format('YYYY-MM'),
    };
    this.setState({
      params: tempParams,
    });
    this.fetchReleaseOrgList(tempParams);
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchReleaseOrgList(tempParams);
  };

  handlePanelChange = (value, mode) => {
    this.setState({
      value,
      mode: [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]],
    });
  };

  handleChange = value => {
    this.setState({ value });
  };

  changeTabs = key => {
    const { params } = this.state;
    const tempParams = { ...params, page: 1, pageSize: 10 };
    this.setState(
      {
        activeKey: key,
        params: tempParams,
      },
      () => {
        this.fetchReleaseOrgList(tempParams);
      }
    );
  };

  render() {
    const { loading, dataSource, params, totalElements, mode, value, activeKey } = this.state;
    const { page } = params;
    const dateFormat = 'YYYY-MM';
    const { form, orgId } = this.props;
    const { getFieldDecorator } = form;

    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns: activeKey === 'key1' ? columns : reporterColumns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    const downParams = {
      ...params,
      nodeId: orgId,
    };

    const downLoadUrl =
      activeKey === 'key1'
        ? `${url.url}/web/news/statistics/releaseOrgListExport?${stringify(downParams)}`
        : `${url.url}/web/news/statistics/releaseUserListExport?${stringify(downParams)}`;

    return (
      <Container breStates>
        <ListPage {...pageProps}>
          <Tabs onChange={this.changeTabs} activeKey={activeKey} type="card">
            <TabPane tab="组织发布榜单" key="key1" />
            <TabPane tab="通讯员发布榜单" key="key2" />
          </Tabs>
          <Row className={styles['search-area']}>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="日期">
                <RangePicker
                  format={dateFormat}
                  mode={mode}
                  value={value}
                  onChange={this.handleChange}
                  onPanelChange={this.handlePanelChange}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="组织名称">
                {getFieldDecorator('searchOrgName', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入组织名称" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col offset={20} style={{ textAlign: 'right' }}>
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <div style={{ textAlign: 'right' }}>
              <Tooltip placement="top" title="当前榜单前200名数据">
                <Button href={downLoadUrl}>
                  导出全部明细
                  <Icon type="question-circle" />
                </Button>
              </Tooltip>
            </div>

            <ListTable {...tableProps} />
          </section>
        </ListPage>
      </Container>
    );
  }
}

const FormPublish = Form.create()(Publish);
export default FormPublish;
